import { isDefined } from "@clipboard-health/util-ts";

import { ConfirmBookingBottomSheet } from "../InHome/BookingBottomSheet/ConfirmBookingBottomSheet";
import { VisitBookedBottomSheet } from "../InHome/BookingBottomSheet/VisitBookedBottomSheet";
import { VisitBottomSheet } from "../InHome/VisitBottomSheet/Sheet";
import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import {
  SHIFT_DISCOVERY_IN_HOME_VISIT_BOOKED_MODAL_PATH,
  SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH,
  SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH,
} from "./paths";
import { useInHomeVisitModalsDataContext } from "./useInHomeVisitModalsDataContext";

export function InHomeModalRoutes() {
  const { visit, isVisitLoading, baseNavigationPath } = useInHomeVisitModalsDataContext();

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_MODAL_PATH}`}
        render={({ modalState }) => {
          // We will build a full loading state once GRO-342 is implemented
          // https://linear.app/clipboardhealth/issue/GRO-342/details-modal
          if (!isDefined(visit) && !isVisitLoading) {
            return null;
          }

          return <VisitBottomSheet modalState={modalState} />;
        }}
      />

      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH}`}
        render={({ modalState }) => {
          if (!isDefined(visit)) {
            return null;
          }

          return (
            <ConfirmBookingBottomSheet
              modalState={modalState}
              visit={visit}
              isLoading={isVisitLoading}
            />
          );
        }}
      />

      <ModalRoute
        closeModalPath={baseNavigationPath}
        path={`${baseNavigationPath}/${SHIFT_DISCOVERY_IN_HOME_VISIT_BOOKED_MODAL_PATH}`}
        render={({ modalState }) => {
          if (!isDefined(visit)) {
            return null;
          }

          return (
            <VisitBookedBottomSheet
              modalState={modalState}
              isLoading={isVisitLoading}
              visit={visit}
            />
          );
        }}
      />
    </ModalTransitionSwitch>
  );
}
